import { createContext, useContext } from 'react'
import type { CicdAccess } from '../services/cicd-access-service'

export type CicdAccessState = {
  access: CicdAccess | null
  loading: boolean
  error: boolean
  refresh: () => Promise<void>
}

export const CicdAccessContext = createContext<CicdAccessState | null>(null)

export function useCicdAccess() {
  const context = useContext(CicdAccessContext)
  if (!context) {
    throw new Error('useCicdAccess must be used inside CicdAccessProvider')
  }
  return context
}
